import * as FetchAction from '../../actions/FetchAction';
import { endpoint } from '../../helpers/Endpoints';

export const LOOKUP_SUPPLIERS_BY_CUSTOMER_ID =
	'@sl:LOOKUP_SUPPLIERS_BY_CUSTOMER_ID';
export const LOOKUP_SUPPLIERS_BY_CUSTOMER_ID_SUCCESS =
	'@sl:LOOKUP_SUPPLIERS_BY_CUSTOMER_ID_SUCCESS';
export const LOOKUP_SUPPLIERS_BY_CUSTOMER_ID_ERROR =
	'@sl:LOOKUP_SUPPLIERS_BY_CUSTOMER_ID_ERROR';
export function lookUpSuppliersByCustomerId(customerId: number) {
	return FetchAction.CreateFetchAction({
		startAction: LOOKUP_SUPPLIERS_BY_CUSTOMER_ID,
		method: 'GET',
		url: endpoint.suppliers({ customerId }),
	});
}

export const SET_SELECTED_SUPPLIER = '@sl:SET_SELECTED_SUPPLIER';
export function setSelectedSupplier(supplierId: number) {
	return {
		type: SET_SELECTED_SUPPLIER,
		supplierId,
	};
}

export const RESET_SELECTED_SUPPLIER = '@sl:RESET_SELECTED_SUPPLIER';

export function resetSelectedSupplier() {
	return {
		type: RESET_SELECTED_SUPPLIER,
	};
}
